import React from 'react';
import { Github, Twitter, Mail } from 'lucide-react';

const ProfileWebsite = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white shadow-sm rounded-lg p-6">
          <div className="space-y-6">
            <div className="text-center">
              <h1 className="text-3xl font-semibold text-gray-900">ClashLuke</h1>
              <p className="mt-2 text-gray-600">Software Developer</p>
            </div>

            <div className="flex justify-center space-x-6">
              <a
                href="https://x.com/_clashluke"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Twitter className="h-5 w-5" />
                <span>Twitter</span>
              </a>
              <a
                href="https://github.com/clashLuke"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Github className="h-5 w-5" />
                <span>GitHub</span>
              </a>
              <a
                href="mailto:contact@nestler.sh"
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Mail className="h-5 w-5" />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileWebsite;
